import { shouldInitializePostHog } from './config'
import type { PostHog } from 'posthog-js'

/**
 * Safely capture a product/behavior event.
 * No-op if posthog is null/undefined or not in production (or development with opt-in).
 */
export function safeCapture(
  posthog: PostHog | undefined,
  event: string,
  properties?: Record<string, unknown>,
): void {
  // Defensive: MODE may be undefined in non-Vite or edge build configs
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Vite types say MODE is always set; other bundlers may not
  const mode = import.meta.env.MODE ?? 'development'
  const devEnabled = import.meta.env.VITE_POSTHOG_DEV_ENABLED
  if (!posthog || !shouldInitializePostHog(mode, devEnabled)) return
  posthog.capture(event, properties)
}

/**
 * Capture an exception to PostHog Error Tracking.
 * No-op if posthog is null/undefined or not in production (or development with opt-in).
 * Use for route errors, React errors, mutation failures.
 */
export function captureException(
  posthog: PostHog | undefined,
  error: Error,
  options?: {
    component_stack?: string
    route_id?: string
    feature?: string
    mutation?: string
    error_boundary?: string
    action?: string
    projectId?: string
  },
): void {
  // Defensive: MODE may be undefined in non-Vite or edge build configs
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Vite types say MODE is always set; other bundlers may not
  const mode = import.meta.env.MODE ?? 'development'
  const devEnabled = import.meta.env.VITE_POSTHOG_DEV_ENABLED
  if (!posthog || !shouldInitializePostHog(mode, devEnabled)) return

  posthog.captureException(error, {
    ...options,
  })
}
